import React, { VFC } from 'react';

export const N2br: VFC<{
  children: string | undefined;
}> = ({ children }) => {
  const content: string[] = children ? children.split('\n') : [];
  return <span dangerouslySetInnerHTML={{ __html: content.join('<br/>') }} />;
};
